<template>
    <div :class="{ 'has-logo': showLogo }"
        :style="{ backgroundColor: settings.sideTheme === 'theme-dark' ? variables.menuBg : variables.menuLightBg }">
        <logo v-if="showLogo" :collapse="isCollapse" />
        <el-scrollbar :class="settings.sideTheme" wrap-class="scrollbar-wrapper">
            <el-menu :default-active="activeMenu" :collapse="isCollapse"
                :background-color="settings.sideTheme === 'theme-dark' ? variables.menuBg : variables.menuLightBg"
                :text-color="settings.sideTheme === 'theme-dark' ? variables.menuText : 'rgba(0,0,0,.65)'"
                :unique-opened="true" :active-text-color="settings.theme" :collapse-transition="false" mode="vertical">
                <sidebar-item v-for="(route, index) in sidebarRouters" :key="route.path + index" :item="route"
                    :base-path="route.path" :isOpened="sidebar.opened" />
            </el-menu>
        </el-scrollbar>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/assets/styles/variables.scss";
import { session } from "@/utils/session";

import { menu } from '@/utils/routeMenu';
export default {
    components: { SidebarItem, Logo },
    computed: {
        ...mapState(["settings"]),
        ...mapGetters(["sidebar"]),
        activeMenu() {
            const route = this.$route;
            const { meta, path } = route;
            if (meta.activeMenu) {
                return meta.activeMenu;
            }
            return path;
        },
        showLogo() {
            return true;
        },
        variables() {
            return variables;
        },
        isCollapse() {
            return !this.sidebar.opened;
        }
    },
    data() {
        return {
            sidebarRouters: [],
            rouleList: [],
            rouleId: localStorage.getItem('rouleId'),
            isAdmin: localStorage.getItem('IsAdmin'),
            checkList: [],
            menuList: []
        }
    },
    async created() {
        this.rouleList = JSON.parse(localStorage.getItem('rouleList'));
        var applications = []
        this.rouleList.forEach(item => {
            if (this.rouleId == item.RoleId) {
                applications = item.Applications;
                localStorage.setItem('applications',JSON.stringify(applications))
            }
        })
        var list = this.loadMenu3(applications)
        this.sidebarRouters = await this.loadMenu2(list)
        console.log(this.sidebarRouters);

    },
    mounted() {
    },
    methods: {
        loadMenu3(list) {
            return list.filter(item => {
                if (item.route_name && (item.type == 1 || item.type == 2)) {
                    if(item.children) {
                        item.children = this.loadMenu3(item.children)
                    }
                    return true
                } else {
                    return false
                }
            })
        },
        async loadMenu2(list) {
            return list.filter(async item => {
                item.meta = { title: item.name, icon: item.icon }
                item.path = item.url
                if (item.children && item.children.length > 0) {
                    item.children = await this.loadMenu2(item.children)
                }else{
                    delete item.children
                }
            })
        },
        loadMenu(list) {
            return list.filter(async item => {

                item.path = '/financialManagement' + item.id
                item.meta = { title: item.name, icon: item.icon }
                // if(this.checkList.includes(item.meta.title)){
                //     item.hidden = false;
                // }else{
                //     item.hidden = true;
                // }
                if (item.children && item.children.length > 0) {
                    item.children = await this.loadMenu(item.children)
                }
            })
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/index.vue